import axios from "axios";
import {INVOICE_API_URL} from "../constants/api_routes";
import {getHeader} from "./user_api";

export const getInvoices = async (startDate,endDate) => {
    try {
        if(startDate && endDate){
            return await axios.get(`${INVOICE_API_URL}/list?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        }
        else {
            return await axios.get(`${INVOICE_API_URL}/list`, {headers: getHeader()});
        }
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getInvoiceEstimateList = async () => {
    try {
        return await axios.get(`${INVOICE_API_URL}/estimates/list`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getInvoiceDetail = async (id) => {
    try {
        return await axios.get(`${INVOICE_API_URL}/detail?invoice_id=${id}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const getEstimateDetails = async (id) => {
    try {
        return await axios.get(`${INVOICE_API_URL}/estimates/detail?estimate_id=${id}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


export const changeInvoiceStatus = async (formData) => {
    try {
        return await axios.post(`${INVOICE_API_URL}/update_status`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


export const updateAdjustment = async (formData,actionType) => {
    try {
        return await axios.post(`${INVOICE_API_URL}/adjustments/${actionType}`,formData, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const deleteAdjustment = async (adjustmentId) => {
    try {
        return await axios.delete(`${INVOICE_API_URL}/adjustments/delete?invoice_adjustment_id=${adjustmentId}`, {headers: getHeader()});
    } catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const regenerateInvoice = async (invoiceId) => {
    try {
        return await axios.post(`${INVOICE_API_URL}/regenerate_invoice`,{invoice_id:invoiceId},{headers:getHeader()});
    }
    catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};

export const sendInvoiceMail = async (invoiceId) => {
    try {
        return await axios.post(`${INVOICE_API_URL}/send_email`,{invoice_id:invoiceId},{headers:getHeader()});
    }
    catch (e) {
        return {
            success: false,
            message: e.response,
            status: e.response.status
        }
    }
};


// WEBPACK FOOTER //
// ./src/data/account_invoice_api.js